import BaseInputArea from "../../components/base_elements/BaseInputArea"
import BaseInputField from "../../components/base_elements/BaseInputField"
import { ReactComponent as SEND } from "../../assets/Send.svg"
import { OrderType } from "../types"
import { Checkbox, Form } from "antd"
import { useForm } from "antd/es/form/Form"
import dayjs from "dayjs"
import { useState } from "react"

type FormularType = {
    newOrder: OrderType
    setnewOrder: (e: any) => void // TODO any
    handleAddNewOrder: () => void
}

export default function Formular(props: FormularType) {
    const [form] = useForm()
    const [checkbox1, setCheckbox1] = useState<boolean>(false)
    const [checkbox2, setCheckbox2] = useState<boolean>(false)
    return (
        <div className="flex flex-col w-1/2 bg-white rounded-default shadow-lg p-4 gap-4 overflow-y-scroll">
            <h3 className="font-bold underline text-xl uppercase">Auftrag erteilen</h3>
            <Form form={form}>
                {/* FORMULAR */}
                <div className="overflow-y-scroll grow gap-4 flex flex-col">
                    <Form.Item name="object" rules={[{ required: true, message: "Muss einen Wert enthalten" }]} className="m-0">
                        <BaseInputField
                            explainText={{
                                text: "Bitte geben Sie das Objekt ein.",
                            }}
                            label={"Straße Nummer, Postleizahl Ort"}
                            type={"text"}
                            onChange={(e: string) =>
                                props.setnewOrder((prev: undefined | OrderType) => ({
                                    ...prev,
                                    objectFromCustomer: e,
                                }))
                            }
                        />
                    </Form.Item>
                    <Form.Item name="activity" className="m-0" rules={[{ required: true, message: "Muss einen Wert enthalten" }]}>
                        <BaseInputField
                            explainText={{
                                text: "Bitte formulieren Sie ein kurze, prägnante Zusammenfassung des Auftrags.",
                            }}
                            label={"Aufgabentitel"}
                            type={"text"}
                            onChange={(e: string) =>
                                props.setnewOrder((prev: undefined | OrderType) => ({
                                    ...prev,
                                    requestTask: e,
                                }))
                            }
                        />
                    </Form.Item>
                    <div className="flex flex-row gap-4">
                        <Form.Item className="m-0 w-1/2" name="descriptionTask" rules={[{ required: true, message: "Muss einen Wert enthalten" }]}>
                            <BaseInputArea
                                explainText={{
                                    text: "Bitte beschreiben Sie Ihren Auftrag möglichst genau. Was ist zutun, an welcher Stelle,...?",
                                }}
                                label={"Beschreibung des Auftrags"}
                                onChange={(e: string) =>
                                    props.setnewOrder((prev: undefined | OrderType) => ({
                                        ...prev,
                                        descriptionTaskFromCustomer: e,
                                    }))
                                }
                            />
                        </Form.Item>
                        <BaseInputArea
                            classProps="m-0 !w-1/2"
                            explainText={{
                                text: "Sofern wir etwas bei der Rechnungserstellung konkret beachten müssen, bitte vermerken Sie es hier.",
                            }}
                            label={"Operative Beschreibung (optional)"}
                            onChange={(e: string) =>
                                props.setnewOrder((prev: undefined | OrderType) => ({
                                    ...prev,
                                    descriptionOrder: e,
                                }))
                            }
                        />
                    </div>
                    <div className="flex flex-row gap-4">
                        <Form.Item className="m-0 w-1/2" name="dueDate" rules={[{ required: true, message: "Muss einen Wert enthalten" }]}>
                            <BaseInputField
                                label={"Fälligkeitsdatum"}
                                explainText={{
                                    text: "Bis wann muss der Auftrag spätestens erledigt sein?",
                                }}
                                type={"date"}
                                onChange={(e: any) =>
                                    props.setnewOrder((prev: undefined | OrderType) => ({
                                        ...prev,
                                        dueDate: dayjs(e).toDate(),
                                    }))
                                }
                            />
                        </Form.Item>
                        <Form.Item className="m-0 w-1/2" name="price" rules={[{ required: true, message: "Muss einen Wert enthalten" }]}>
                            <BaseInputField
                                label={"Preis für Freigabe"}
                                explainText={{
                                    palcement: "top",
                                    text: "Beispiel: wenn die Erledigung der Aufgabe xxx,00€ kostet, ist die Freigabe erteilt. Bitte geben Sie den Wert für >xxx< ein.",
                                }}
                                type={"Number"}
                                onChange={(e: string) =>
                                    props.setnewOrder((prev: undefined | OrderType) => ({
                                        ...prev,
                                        priceForReleaseFromCustomer: Number(e),
                                    }))
                                }
                            />
                        </Form.Item>
                    </div>
                    <div className="flex flex-row gap-4">
                        <BaseInputField
                            label={"Ansprechpartner (optional)"}
                            type={"text"}
                            onChange={(e: string) =>
                                props.setnewOrder((prev: undefined | OrderType) => ({
                                    ...prev,
                                    contactPerson: e,
                                }))
                            }
                            explainText={{
                                palcement: "top",
                                text: "Falls der Ansprechpartner von den uns bekannten Personen abweicht, bitte hier angeben.",
                            }}
                        />
                        <BaseInputField
                            explainText={{
                                palcement: "top",
                                text: "Falls es einen anderen Ansprechpartner gibt, bitte hier die Telefonnummer für Rückfragen hinterlegen.",
                            }}
                            label={"Telefonnummer (optional)"}
                            type={"tel"}
                            onChange={(e: string) =>
                                props.setnewOrder((prev: undefined | OrderType) => ({
                                    ...prev,
                                    contactTel: e,
                                }))
                            }
                        />
                    </div>
                </div>
                {/* CHECKBOX & SAVE BUTTON */}
                <div className="flex w-full justify-between items-end pt-2 text-xs">
                    <div className="flex flex-col gap-1 items-start justify-center pl-4">
                        <Form.Item name="checkbox1" rules={[{ required: true, message: "" }]} className="flex items-center m-0">
                            <Checkbox
                                value={checkbox1}
                                onClick={() => setCheckbox1(!checkbox1)}
                            />
                            <label className="text-xs pl-4">Ich akzeptiere die Datenschutzbestimmungen des Besitzwerks.</label>
                        </Form.Item>
                        <Form.Item className="flex items-center m-0" name="checkbox2" rules={[{ required: true, message: "" }]}>
                            <Checkbox value={checkbox2} onClick={() => setCheckbox2(!checkbox2)} />
                            <label className="text-xs pl-4">
                                Ich akzeptiere, dass mit Absendung dieser Anfrage ein verbindlicher Auftrag entstehen kann.
                            </label>
                        </Form.Item>
                    </div>
                    <button
                        type="submit"
                        className=" btn btn-primary btn-outline"
                        disabled={!checkbox1 || !checkbox2}
                        onClick={() => props.handleAddNewOrder()}>
                        Auftrag anfragen
                        <SEND className="w-6 h-6" />
                    </button>
                </div>
            </Form>
        </div>
    )
}
